module.exports = __webpack_public_path__ + "public/img/skills-week.695a3708.png";